module.exports = __webpack_public_path__ + "static/media/sleepnix-2.2a41cb9c.jpg";